import { FC } from "react";
import { FaqComponent } from "components";
import useFaqs from "constants/useFaqs";

interface FaqSectionProp {
  bgColor?: string;
}

export const FaqSection: FC<FaqSectionProp> = ({ bgColor }) => {
  let faqs = useFaqs();
  return (
    <div className={`bg-pbg ${bgColor}`}>
      <div className="py-16 md:py-24 px-4 md:px-16">
        <div className="flex flex-col gap-12 w-full md:w-[620px] referral-container">
          <p className="text-blueShades-4 text-4xl md:text-5xl font-SatoshiBold md:text-center">
            Frequently Asked Questions
          </p>
          <div className="flex flex-col gap-6">
            {faqs.map((faq, index) => (
              <FaqComponent
                key={index}
                question={faq.question}
                answer={faq.answer}
                cta={faq.cta}
              />
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};
